import React, { Fragment } from 'react'
import styled from 'styled-components'
import { FormattedMessage } from 'react-intl'
import { fonts, H5 } from 'app/common/typography'
import { ListView } from './ListView'
import { MapView } from './MapView'
import { List, Map } from 'app/assets/icons'
import { media } from 'app/assets/styles'
import { colors as oldColors } from 'shared/assets/styles'
import { COLOR } from 'app-v2/design-tokens'

const { yellow } = oldColors
const { roboto } = fonts

type SplitRestaurantChoiceScreenProps = {
    listView: boolean,
    setListView: any
}

export const SplitRestaurantChoiceScreen = ({
    listView = true,
    setListView
}: SplitRestaurantChoiceScreenProps) => {
    const renderTitle = () => {
        return (
            <FormattedMessage id="clickandcollect.search.restaurant.title">
                {(label: string) => (
                    <StyledTitle font={roboto}>{label}</StyledTitle>
                )}
            </FormattedMessage>
        )
    }

    const renderSwitchIcons = () => {
        return (
            <IconsContainer>
                <ListIconContainer
                    active={listView}
                    onClick={() => setListView(true)}>
                    <List color={listView ? 'white' : yellow} />
                </ListIconContainer>
                <MapIconContainer
                    active={!listView}
                    onClick={() => setListView(false)}>
                    <Map
                        stroke={listView ? yellow : 'white'}
                        color="transparent"
                    />
                </MapIconContainer>
            </IconsContainer>
        )
    }

    return (
        <Fragment>
            <TitleContainer>
                {renderTitle()}
                {renderSwitchIcons()}
            </TitleContainer>
            {listView ? <ListView /> : <MapView />}
        </Fragment>
    )
}

const TitleContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    margin: 20px 20px 0;
    ${media.medium`
        justify-content: center;
    `}
`

const StyledTitle = styled(H5)`
    color: ${COLOR.PRIMARY};
    font-weight: 700;
    ${media.medium`
        padding-right: 20px;
    `}
`

const IconsContainer = styled.div`
    display: flex;
    flex-direction: row;
    border-radius: 10px;
    width: 76px;
    cursor: pointer;
    border: 1px solid ${yellow};
`

const ListIconContainer = styled.div`
    background-color: ${props => (props.active ? `${yellow}` : `white`)};
    padding: 5px 5px 3px;
    padding-left: 8px;
    border-bottom-left-radius: 10px;
    border-top-left-radius: 10px;
`

const MapIconContainer = styled.div`
    background-color: ${props => (props.active ? `${yellow}` : `white`)};
    padding: 5px 5px 3px;
    padding-right: 10px;
    border-bottom-right-radius: 10px;
    border-top-right-radius: 10px;
`
